import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";
import _ from 'lodash';
import lscache from 'lscache';
import { terminal } from "../../../../../config/Constantes";
import { sortCaret } from '../../../../comum/components/Icones';
import { formatarDataCustomHTML, formatarCheck, exibirItensArray, situacaoFormatter, 
    situacaoBookingFormater, appendFieldObjSpan, formatarData, formataZero,
    formatNullableValue, formatarPopOver, navioDataPopOver  } from '../../../../../utils/formatar';
    import { buscaFiltrarVazio, buscaSemResultado } from '../../../../../utils/mensagens';
    import BookingService from "../../../../../services/BookingService";
import { propTypes } from "mobx-react";
export default class CardBookingStore {

    @observable codigoBooking;
    @observable expandido;
    tipoAgenda;
    @observable bookingLista;
    @observable colunas;
    //TODO - Observar impactos da retirada do tiposContainer desta store
    @observable tiposContainer;
    @observable armadores;
    @observable portos;
    @observable destinos;
    @observable editandoBooking;

    /* Containers */
    @observable ISOs;
    @observable categorias;
    @observable tiposDeLacre;
    @observable todosTiposDeLacre;
    @observable tiposMercadoria;

    @observable portosBloqueado;
    @observable ISOsBloqueado;
    @observable bloqueadoRespOvacao;
    @observable tiposMercadoriaBloqueado;

    @observable listaMensagens;
    @observable atualizandoClientes;
    @observable atualizandoNcm;
    @observable atualizandoRespOva
    @observable atualizandoContainer
    @observable atualizaCodCtnr;

    containerModificando;

    constructor(tipoAgenda) {
        this.tipoAgenda = tipoAgenda;
        this.codigoBooking = false;
        this.tiposContainer = [];
        this.armadores = [];
        this.portos = [];
        this.destinos = [];
        this.editandoBooking = true;

        // Containers
        this.ISOs = false;
        this.categorias = [];
        this.tiposDeLacre = [];
        this.todosTiposDeLacre = [];
        this.tiposMercadoria = [];

        this.portosBloqueado = true;
        this.ISOsBloqueado = true;
        this.bloqueadoRespOvacao = [];
        this.tiposMercadoriaBloqueado = true;

        this.atualizandoClientes = false;
        this.atualizandoRespOva = false;
        this.atualizandoNcm = false;
        this.atualizandoContainer = false;
        this.atualizaCodCtnr = "";
        this.expandido = true;

        this.listaMensagens = false;
        this.bookingLista = [];
        this.todasColunas = [{
            dataField: 'booking.Nbr',
            text: 'Booking',
            headerStyle: () => {
                return { maxWidth: "80px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'booking.VesselName',
            text: 'Navio / Viagem',
            searchable: false,           
            formatter: navioDataPopOver, 
            formatExtraData: 'booking-VesselVisit', //eu preciso passar um - no lugar do ponto pois, booking.VesselVisit só me manda booking. Posso averiguar mais tarde.
            events: {onClick: this.clickPopOverNavio},
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'booking.LineOperator',
            text: 'Armador',
            searchable: false,
            headerStyle: () => {
                return { maxWidth: "80px" };
            },
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'booking.VesselDeadLine',
            text: 'Deadline Op.',
            searchable: false,
            formatter: formatarDataCustomHTML,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'booking.Pod',
            text: 'Porto Desc.',
            searchable: false,
            headerStyle: () => {
                return { maxWidth: "140px" };
            },
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'booking.Destination',
            text: 'Destino',
            searchable: false,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'itens',
            text: 'Tam / Tipo',
            sortCaret: sortCaret,
            searchable: false,
            formatter: exibirItensArray,
            formatExtraData: 'Tipo'
        },{
            dataField: 'booking.QtdAgendBkn',
            text: 'Qtd. Agendados',
            searchable: false,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'itens',
            text: 'Qtd. Prev.',
            formatter: exibirItensArray,
            formatExtraData: 'Qtd',
            searchable: false,
            sortCaret: sortCaret,
        }, {
            dataField: 'itens',
            text: 'Pátio',
            searchable: false,
            formatter: exibirItensArray,
            formatExtraData: 'Patio',
            sortCaret: sortCaret,
        }, {
            dataField: 'itens',
            text: 'Saída',
            searchable: false,
            formatter: exibirItensArray,
            formatExtraData: 'Saida',
            sortCaret: sortCaret,
        }, {
            dataField: 'booking.Status',
            text: 'Situação Navio',
            searchable: false,
            sort: true,
            sortCaret: sortCaret,
            formatter: situacaoFormatter
        }];
        
         this.colunas = this.todasColunas;
        
        this.desbloqCamposMercadoria = ['Temperatura_Desloqueado', 'Umidade_Desloqueado', 'Ventilacao_Desloqueado', 'UN_Desloqueado'];
        this.camposMercadoria = ['ValUmid', 'ValVent', 'ValTmpIdea', 'IdUn'];

        this.service = new AgendamentoContainerService();
        this.bookingService = new BookingService();
    };

    atualizaContainer(status) {
        this.atualizandoContainer = status;
    }

    setContainerAtualizado(codCtnr) {
        this.atualizaCodCtnr = codCtnr;
    }

    carregarTiposMercadorias = (cdiso) => {
    
        this.tiposMercadoria = [];
        this.tiposMercadoriaBloqueado = true;
        if (cdiso && this.tipoAgenda.value !== 0 && this.ISOs) {
            let i = this.ISOs.filter(iso => iso.CdIso === cdiso)
            if (i.length > 0)
                this.buscarTiposMercadoria(this.tipoAgenda.value, (i[0].Refrigerado === "V"))
        }
    };
    
    carregarLista(numeroBooking) {
        this.filtrado = true;
        
        this.seletorPeriodo = false;
        this.bookingLista = [];
        const booking = (numeroBooking.NumBookingTemp) ? numeroBooking.NumBookingTemp : numeroBooking;
        this.bookingService.listarDetalhes(booking).then(response => {
            this.bookingLista = response.data.Data;
            this.loadFirstTurn()
            this.total = response.data.Total;
            //this.hasNextPage = response.data.HasNextPage;
        }).catch(error => {
            console.log(error);
        })
    }

    
    carregarTiposDeContainer = (numBooking) => {
        this.tiposContainer = false;
        if (numBooking) {
            this.service.listarTipoContainer(numBooking).then(response => {
                if (response)
                    this.tiposContainer = response.data;
            }).catch(error => {
                console.log(error);
            })
        }
    };

    carregarArmadores = (oper) => {
        if (oper)
            this.service.listarArmadores(oper, "S").then(response => {
                this.armadores = response.data;
            }).catch(erro => {
                console.log(erro)
            });
    };

    carregarPortos = (armador, oper) => {
        this.portos = [];
        this.portosBloqueado = true;
        if (armador && oper) {
            this.service.listarPortos(armador, oper).then(response => {
                if (response.data) {
                    this.portos = response.data;
                    this.portosBloqueado = false;
                } else this.portosBloqueado = true;
            }).catch(erro => {
                console.log(erro)
            });
        }
    };

    carregarDestinos = () => {
        this.service.listarDestinos().then(response => {
            this.destinos = response.data;
        }).catch(erro => {
            console.log(erro)
        });
    };

    carregarISOs = (tipoContainer, numBooking) => {
        this.ISOs = false;
        this.ISOsBloqueado = true;
        if (tipoContainer)
            this.service.listarISOs(tipoContainer, numBooking).then(response => {
                this.ISOs = response.data;
                this.ISOsBloqueado = false;
            }).catch(erro => {
                console.log(erro)
            });
    };

    carregarMercadoria = (ncm, container, setdados) => {
        this.containerModificando = container;
        if (ncm && ncm.length > 0) {
            this.service.buscarMercadoriaPorNcm(ncm).then(response => {
                if (response.data.Id) {
                    this.setNCM(setdados, response.data.Id, response.data.Desc, "");
                } else {
                    this.setNCM(setdados, null, null, "NCM não encontrado");
                }
                this.atualizandoNcm = true;
                setTimeout(function () {
                    this.atualizandoNcm = false
                }.bind(this), 1);
            })
        } else {
            this.setNCM(setdados, null, null, null);
            this.atualizandoNcm = true;
            setTimeout(function () {
                this.atualizandoNcm = false
            }.bind(this), 1);
        }

    };

    setNCM = (setdados, MercId, NCM_descricaoMercadoria, NCM_lblNaoExiste) => {
        setdados(`${this.containerModificando}.MercId`, MercId)
        setdados(`${this.containerModificando}.NCM_descricaoMercadoria`, NCM_descricaoMercadoria)
        setdados(`${this.containerModificando}.valid.NCM_lblNaoExiste`, NCM_lblNaoExiste)
    };

    mostraMsgSobreCliente = () => {
        this.service.buscarMensagensParaCliente(this.tipoAgenda.codIdentificador).then(response => {
            if (response && response.data && response.data.Message !== "") {
                this.listaMensagens = response.data.Message.split("<br />");
            }
        }).catch(erro => {
            console.log(erro)
        });
    };

    fecharModais = () => {
        this.listaMensagens = false;
    };

    carregarClientes = (cnpj, container, setdados, isRIG, emiteMsg = true) => {
        this.containerModificando = container;
        if (cnpj && cnpj.length > 0) {
            if (isRIG && emiteMsg) this.mostraMsgSobreCliente();
            this.service.buscarClientePorCnpj(cnpj).then(response => {
                if (response.data) {
                    setdados(`${this.containerModificando}.RazSocialCliente`, response.data.RazaoSocialEmpParcComerc);
                    setdados(`${this.containerModificando}.ClibrsId`, response.data.ClibrsClibrsIdSai);
                    setdados(`${this.containerModificando}.ClibrsIdCobrade`, response.data.ClibrsClibrsIdSai);
                    setdados(`${this.containerModificando}.valid.CnpjCliente_lblNaoExiste`, "");

                    this.atualizandoClientes = true
                    setTimeout(function () {
                        this.atualizandoClientes = false
                    }.bind(this), 1)
                } else {
                    
                    this.clienteNaoCadastrado(setdados);
                    setdados(`${this.containerModificando}.valid.CnpjCliente_lblNaoExiste`, "Cliente não cadastrado");
                }
            }).catch(erro => {
                console.log(erro)
            });
        } else {
            this.clienteNaoCadastrado(setdados);
            setdados(`${this.containerModificando}.valid.CnpjCliente_lblNaoExiste`, "");
        }

    };

    clienteNaoCadastrado = (setdados) => {
        this.atualizandoClientes = true

        setdados(`${this.containerModificando}.RazSocialCliente`, "");
        setdados(`${this.containerModificando}.ClibrsId`, 0);
        setdados(`${this.containerModificando}.ClibrsIdCobrade`, 0);

        setTimeout(function () {
            this.atualizandoClientes = false
        }.bind(this), 1)
    };

    setRespOvacaoBloqueado = (index, bool) => {
        if (this.bloqueadoRespOvacao.length === 0) {
            for (let i = 0; i <= index; i++)
                this.bloqueadoRespOvacao.push(true);
        }

        if (index != null) {
            this.bloqueadoRespOvacao[index] = bool;
        }
    }

    carregarRespOva = (cnpj, container, setdados, isRIG, indexContainer = null, salvarDados = true) => {
        this.containerModificando = container;
        this.setRespOvacaoBloqueado(indexContainer, false);
        if (cnpj && cnpj.length > 0) {
            this.service.buscarClientePorCnpj(cnpj).then(response => {
                if (response.data) {
                    if (salvarDados) {
                        setdados(`${this.containerModificando}.RazSocialRespOva`, response.data.RazaoSocialEmpParcComerc);
                        setdados(`${this.containerModificando}.valid.CnpjRespOva_lblNaoExiste`, "");
                    }
                    if (isRIG) this.mostraMsgSobreCliente();
                    this.setRespOvacaoBloqueado(indexContainer, true);
                    this.atualizandoRespOva = true
                    setTimeout(function () {
                        this.atualizandoRespOva = false
                    }.bind(this), 1)
                } else {
                    setdados(`${this.containerModificando}.valid.CnpjRespOva_lblNaoExiste`, "Cliente não cadastrado");
                }
            }).catch(erro => {
                console.log(erro)
            });
        }
    };

    carregarCategorias = (destino = "") => {

        if(terminal !== "RIG" || !destino)
            this.categorias = [{ value: "C", label: "Cabotagem" }, { value: "E", label: "Exportação" }];
        else if(destino.toUpperCase().substring(0,2) === "BR")
            this.categorias = [{ value: "C", label: "Cabotagem" }];
        else
            this.categorias = [{ value: "E", label: "Exportação" }];
            
    };

    carregarLacres = () => {
        this.todosTiposDeLacre = [{ value: "ARM", label: "Lacre Armador" }, { value: "TER", label: "Lacre Terminal" },
        { value: "SIF", label: "Lacre SIF" }, { value: "EXP", label: "Lacre Exp/Imp" }];
        this.tiposDeLacre = [];
        this.tiposDeLacre.push(this.todosTiposDeLacre);
        this.tiposDeLacre.push(this.todosTiposDeLacre);
        this.tiposDeLacre.push(this.todosTiposDeLacre);
        this.tiposDeLacre.push(this.todosTiposDeLacre);
    };

    changeTiposMercadoria(container, event, set, terminal) {
        /** bloquear campos até que seja verificado quais estão desbloqueados */
        let camposBloqueados = ['Temperatura_Desloqueado', 'Umidade_Desloqueado', 'Ventilacao_Desloqueado', 'UN_Desloqueado'];
        this.setCamposMercadoria(false, camposBloqueados, set, container);

        let camposDesbloqueados = [];
        let limparCampos = [];

        if (terminal === "RIG") {
            switch (event) {
                /** Resíduo Perigoso */
                case 6:
                    camposDesbloqueados = ['UN_Desloqueado'];
                    limparCampos = ['ValUmid', 'ValVent', 'ValTmpIdea'];
                    break;
                /** Refrigerada e Perigosa */
                case 4:
                    camposDesbloqueados = ['Temperatura_Desloqueado', 'Umidade_Desloqueado', 'Ventilacao_Desloqueado', 'UN_Desloqueado'];
                    limparCampos = [];
                    break;
                /** Perigosa */
                case 3:
                    camposDesbloqueados = ['UN_Desloqueado'];
                    limparCampos = ['ValUmid', 'ValVent', 'ValTmpIdea'];
                    break;
                /** Refrigerada */
                case 2:
                    camposDesbloqueados = ['Temperatura_Desloqueado', 'Umidade_Desloqueado', 'Ventilacao_Desloqueado'];
                    limparCampos = ['IdUn'];
                    break;
                /** Seca */
                default:
                    limparCampos = ['ValUmid', 'ValVent', 'ValTmpIdea', 'IdUn'];
                    break;
            }
        }

        this.setCamposMercadoria(true, camposDesbloqueados, set, container);
        this.setCamposMercadoria(null, limparCampos, set, container);
    };

    changeTiposMercadoriaValor(container, event, set, terminal, dadosMercadoria, dadosContainer) {
        //Obtendo os dados da Mercadoria           
        let ValTmpIdea = dadosContainer.ValTmpIdea !== null ? dadosContainer.ValTmpIdea : dadosMercadoria.temperatura;
        let ValUmid = dadosContainer.ValUmid !== null ? dadosContainer.ValUmid : dadosMercadoria.umidade;
        let ValVent = dadosContainer.ValVent !== null ? dadosContainer.ValVent : dadosMercadoria.ventilacao;
        let IdUn = dadosContainer.IdUn !== null ? dadosContainer.IdUn : dadosMercadoria.un;

        let campos = ['ValUmid', 'ValVent', 'ValTmpIdea', 'IdUn'];
        let valores = [ValTmpIdea,
            ValUmid,
            ValVent,
            IdUn];

        this.setCamposMercadoria(null, campos, set, container);

        if (terminal === "RIG") {
            switch (event) {
                /** Resíudo Perigoso */
                case 6:
                    campos = ['ValUmid', 'ValVent', 'ValTmpIdea', 'IdUn'];
                    valores = [null,
                        null,
                        null,
                        IdUn];
                    break;
                /** Refrigerada e Perigosa */
                case 4:
                    campos = ['ValUmid', 'ValVent', 'ValTmpIdea', 'IdUn'];
                    valores = [ValUmid,
                        ValVent,
                        ValTmpIdea,
                        IdUn];
                    break;
                /** Perigosa */
                case 3:
                    campos = ['ValUmid', 'ValVent', 'ValTmpIdea', 'IdUn'];
                    valores = [null,
                        null,
                        null,
                        IdUn];
                    break;
                /** Refrigerada */
                case 2:
                    valores = [ValUmid,
                        ValVent,
                        ValTmpIdea,
                        null];
                    break;
                /** Seca */
                default:
                    valores = [null,
                        null,
                        null,
                        null];
                    break;
            }
        }

        this.setCamposMercadoriaValor(valores, campos, set, container);
    };


    validarISOCarregarMercadorias = (cdiso, container, setdados) => {
        this.containerModificando = container;
        this.tiposMercadoria = [];
        this.tiposMercadoriaBloqueado = true;
        // Não desejo fazer uma requisição com o valor de cdiso vazio
        if (cdiso != null && cdiso.length > 0) {
            //setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "Buscando ISO");
            this.service.validarISO(cdiso).then(response => {
                if (response.data) {
                    this.buscarTiposMercadoria(this.tipoAgenda.value, response.data.Refrigerado === "V")
                    setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "");
                } else {
                    setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "ISO não encontrado");
                }
            }).catch(erro => {
                console.log(erro)
                //setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "");
            });
        } else {
            setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "");
            this.tiposMercadoria = [];
            //eu mando limpar o lblNaoExiste pois o usuario pode limpar o resultado depois
        }
    };

    setCamposMercadoria = (valor, arr, set, container) => {
        arr.map(item => {
            set(`${container}.${item}`, valor);
        });
    };

    setCamposMercadoriaValor = (valor, arr, set, container) => {
        arr.map((item, x) => {
            set(`${container}.${item}`, valor[x]);
        });
    };

    buscarTiposMercadoria = (tipoAgenda, isRefrigerada) => {
        this.service.buscarTiposMercadoria(tipoAgenda, isRefrigerada).then(response => {
            if (response.data) {
                this.tiposMercadoria = response.data;
                this.tiposMercadoriaBloqueado = false;
            }
        }).catch(erro => {
            console.log(erro)
        });
    };

    clickExpandir = (booking) => {
        this.expandido = !this.expandido;
        if (this.ISOs && this.ISOs.length == 0) {
            this.carregarISOs(booking.CdTipoCntr, booking.NumBooking)
        }
    };

    clickEsconder = () => {
        this.expandido = !this.expandido;
    };
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/stores/CardBookingStore.js